<div *ngIf="!isLoading; else loading">
  <div *ngIf="!isLoading && deviceData">
    <div class="wrapper">
      <div class="top-bar">
        <div class="content"></div>
        <div>
          <img
            src="assets/images/ecolab-logo-white-app-header.png"
            alt="EcoLab Logo"
            class="logo"
          />
        </div>
        <div class="content-end">
          <!-- *ngIf="isPageLoaded" -->
          <select
            [value]="currentLanguage"
            (change)="languageChange($event)"
            class="select-dropdown"
          >
            <option
              *ngFor="let option of languageOptions"
              [value]="option?.value"
              [selected]="option.value === currentLanguage"
            >
              {{ option.value }}
            </option>
          </select>
        </div>
      </div>
      <div class="overflow-hidden">
        <div class="object-fit-fill h-100 p-relative position-relative before">
          <div class="overflow-scroll h-100">
            <div class="main">
              <div class="header pt-5 headermain">
                {{ translations['help_message'] }}
                <div class="sub-header">
                  <div class="pr-2">{{ translations['device_info'] }}</div>
                  {{ selectedMachineName }}?
                </div>
              </div>
              <div class="d-flex justify-content-center headermain machine">
                <div class="pb-2">
                  <img
                    class="img-machine"
                    *ngIf="machineImageUrl"
                    [src]="machineImageUrl"
                  />
                </div>
                <div>
                  <button
                    class="btn-machine"
                    routerLink="dishmachineModel"
                    (click)="navigate('dishmachineModel')"
                  >
                    <img
                      src="./assets/images/icon/change.png"
                      class="img-change"
                    />
                    {{ translations['change'] }}
                  </button>
                </div>
              </div>
            </div>

            <div class="container pb-2">
              <a class="support-link" (click)="navigate('troubleShootDesc')">
                <div class="w-18 mr-15">
                  <img
                    src="./assets/images/icon/troubleshooting.png"
                    class="img-trouble"
                  />
                </div>
                {{ translations['support_text'] }}
              </a>
              <a
                class="support-link"
                href="{{ disMachineDetail?.productUrl }}"
                (click)="navigate('productInfo')"
              >
                <div class="w-18 mr-18">
                  <img
                    class="img-product"
                    src="./assets/images/icon/productInfo.png"
                  />
                </div>
                {{ translations['product_info_text'] }}
              </a>
              <a class="support-link" (click)="navigate('training')">
                <div class="w-18 mr-15">
                  <img class="img-play" src="./assets/images/icon/play.png" />
                </div>
                {{ translations['training_text'] }}
              </a>
            </div>

            <div class="download">
              <div class="p-2">
                {{ translations['download_message'] }}
                <br />
                <span (click)="download()" class="btn-download">
                  {{ translations['download'] }} DishIQ<sup>TM</sup>
                  <img class="pl-2" src="assets/images/icon/forward.png"
                /></span>
              </div>
              <div>
                <img class="download-img" src="assets/images/dishiq.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="top-bar">
    <div class="content"></div>
    <div>
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <!-- <select>
                <option>English</option>
                <option>Spanish</option>
            </select> -->
    </div>
  </div>
  <div class="d-flex justify-content-center pt-3">
    <div class="loading">Loading</div>
  </div>
</ng-template>

<ng-template *ngIf="!isLoading && !disMachineDetail">
  <div class="top-bar">
    <div class="content"></div>
    <div>
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <select>
        <option>English</option>
        <option>Spanish</option>
      </select>
    </div>
  </div>
  <div class="pt-5 mx-4">
    <div class="d-flex justify-content-center">
      <div class="account-msg">
        Oh no, we can’t find that machine or account.
      </div>
    </div>
    <div class="d-flex justify-content-center pt-3">
      <div class="message-text">
        Please try scanning the QR code again or contact us.
      </div>
    </div>
  </div>
</ng-template>
